// extracted by mini-css-extract-plugin
export var sliderRange = "_cf-2";
export var sliderRoot = "_cf-0";
export var sliderThumb = "_cf-3";
export var sliderTrack = "_cf-1";